import { useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'

const AreasSelector = ({ areas = [], className = '', disabled, loading, placeholder, style = {}, values, onChange }) => {
  const options = useMemo(() => areas.map(a => ({
    label: a.localName,
    value: a.id,
    tooltip: a.localName,
    entity: a
  })), [areas])

  return (
    <EntitiesSelector
      disabled={disabled}
      entityOptions={options}
      loading={loading}
      multiple='default'
      placeholder={placeholder}
      selectorClassName={className}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default AreasSelector
